import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
@Pipe({
  name: 'age'
})
export class AgePipe implements PipeTransform {
  private date: Date;

  transform(value: string): string {
    const today = moment();
    const birthdate = moment(value);
    const years = today.diff(birthdate, 'years');
    let html: string = '';
    if (years > 1) {
      html = years + ' years ';
    } else if (years === 1 ) {
      html = years + ' year ';
    }

    const months = today.subtract(years, 'years').diff(birthdate, 'months');
    if (months > 1) {
      html += months + ' months';
    } else if (months === 1) {
      html += months + ' month';
    }
    if (html.length === 0) {
      html = '< 1 month';
    }
    return html;
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/pipes/age.pipe.ts